export default {
  SET_REGISTER_OWNER: "setRegisterOwner",
  SET_REGISTER_DATE: "setRegisterDate",
  SET_DOBY: "setDoby",
  SET_DOBY_LIST: "setDobyList",
  SET_DOBY_FILES: "setDobyFiles",
  SET_ERROR: "setError",
  SET_RESET: "setReset",
};
